const roundedNumber = (number: number, decimals = 2): number | string => {
  if (number === null || number === undefined) return '- ';
  const numberNew = Number(number);
  return +numberNew.toFixed(decimals);
};
export default roundedNumber;
